module.exports = __webpack_public_path__ + "static/sausage-roll-a22a3de14909e2102ccadaac174ee561.jpg";